import React, { useEffect } from 'react';

import Edit from 'containers/Administrator/Blanks/Profile/Settings/Edit';
import Copy from 'containers/Administrator/Blanks/Profile/Settings/Copy';
import Delete from 'containers/Administrator/Blanks/Profile/Settings/Delete';

const Settings = ({ setTab }) => {
	// Update selected tab
	useEffect(() => setTab(null), [setTab]);

	return (
		<>
			{/* Blank's data edit */}
			<Edit />

			{/* Blank's data edit */}
			<Copy />

			{/* Blank's removal */}
			<Delete />
		</>
	);
};

export default Settings;